import { subscribeWithSelector } from 'zustand/middleware';
import { createStore, StateCreator, StoreApi } from 'zustand/vanilla';
import { StoreSubscribeWithSelector } from './zustandTypes';

type SelectorStateCreator<T> = StateCreator<T, [['zustand/subscribeWithSelector', never]], []>;

export function createStoreWithSelector<T>() {
  return (initializer: SelectorStateCreator<T>): StoreApi<T> & StoreSubscribeWithSelector<T> =>
    createStore<T>()(subscribeWithSelector(initializer));
}
